import React, { useContext } from "react";
import PropType from "prop-types";

import { Route, useHistory } from "react-router-dom";
import { AuthContext } from "../AuthContext";

export default function ContentWriterRoute({ component: Component, ...rest }) {
  const { userIsContentWriter } = useContext(AuthContext);
  const history = useHistory();

  if (!userIsContentWriter()) {
    history.push("/");
  }

  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /signin page
    <Route {...rest} render={(props) => <Component {...props} />} />
  );
}

ContentWriterRoute.propTypes = {
  component: PropType.func.isRequired,
};
